
























import Vue from "vue";
import AppHeader from "@/components/organisms/Header/index.vue";
import AppSidebar from "@/components/organisms/Sidebar/index.vue";
import Breadcrumb from "@/components/organisms/Breadcrumb/index.vue";

export default Vue.extend({
  components: {
    AppHeader,
    AppSidebar,
    Breadcrumb,
  },
  data() {
    return {
      isActiveDesktop: true,
      isActiveMobile: false,
    };
  },
  props: {
    isAuth: {
      type: Boolean,
      default: false,
    },
    isOpenSidebar: {
      type: Boolean,
      default: true,
    },
    isOpenReportGroupModal: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleOnSelectMenu(val: string) {
      if (val === "logout") {
        this.$emit("logout");
      }
    },
    toggleSidebarDesktop() {
      this.isActiveDesktop = !this.isActiveDesktop;
    },
    toggleSidebarMobile() {
      this.isActiveMobile = !this.isActiveMobile;
    },
    getMenuFunction() {
      this.$store.dispatch("report/getReports");
    },
    getClass() {
      let classname = "sidebar";
      if (this.isActiveDesktop) {
        classname += " active-desk";
      }
      if (this.isActiveMobile) {
        classname += " active-mobile";
      }
      return classname;
    },
  },
});
